import r from "react";
import { Text as l } from "../../../Text/Text.js";
import { cls as o } from "../../../../helpers/cls.js";
const c = _ref => {
  let {
    children: e,
    priceMobile: a,
    fixedHeightElements: i
  } = _ref;
  return !e && i ? r.createElement("span", {
    className: "olx-ad-card__price--fixed"
  }) : e ? r.createElement(l.BodyLarge, {
    tag: "h3",
    weight: "semibold",
    className: o("olx-ad-card__price", a && "olx-ad-card__price--mobile")
  }, e) : null;
};
export { c as Price };